import {Directive, ElementRef, Input} from "@angular/core";
import {FORM_ERRORS} from "../_util/validators";

export type FormInputType =
  | 'PASSWORD'
  | 'EMAIL'
  | 'NAME'
  | 'PHONE'
  | 'BOARD_NOTE_NAME'
  | 'LINK_NAME'
  | 'CUSTOM_PLAN_MAX_USERS'
  | 'TRADE_COMPANY_STYLE_MAX_USERS'
  | 'FLOOR_UNIT_NAME'
  | 'ROOM_AREA_NAME'
  | 'ADDRESS'
  | 'ZIP_CODE'
  | 'PROJECT_CODE'
  | 'PROJECT_NUMBER'
  | 'TASK_DESCRIPTION'
  | 'MATERIAL_DESCRIPTION'
  | 'TASK_NAME'
  | 'MATERIAL_QUANTITY'
  | 'MATERIAL_AREA_NAME'
  | 'MEASURES'

@Directive({
    selector: '[formInput]',
    standalone: true
})
export class FormInputDirective {

  @Input('formInput') set inputType(value: FormInputType) {
    if (value === 'PASSWORD') this.el.nativeElement.addEventListener('keydown.space', (event: any) => event.preventDefault());

    this.el.nativeElement.setAttribute('maxLength', FORM_ERRORS[value].MAX_LENGTH_VALUE);
  }

  constructor(private el: ElementRef) {}
}
